import React from 'react';
import Clock from './Clock';
import Weather from './Weather';
import moment from 'moment-timezone';
import _ from 'lodash';

class Header extends React.Component {

    componentDidMount() {
        this.updateTime();
        this.clockInterval = setInterval(
            () => this.updateTime(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.clockInterval);
    }

    updateTime() {
        const timezone = _.get(this.props, 'config.timezone', 'Canada/Eastern');
        const now = moment.tz(timezone);
        this.setState({
            time: now.format('LTS'),
            date: now.format('LL')
        });
    }

    render() {
        return (
            <div className="header">
                <Clock {...this.state}/>
                <Weather/>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/dashboard/header/Header.js